import React from "react";
import {CheckCircle} from "react-feather"

interface Props {
  open: boolean;
  title: string;
  onClose: () => void;
  error?: boolean;
  helperText?: string;
  textColor?: string;
}
export const ModalMessage: React.FC<Props> = ({
  open,
  title,
  onClose,
  error,
  helperText,
  textColor,
}) => {

  return (
    <>
      {open ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-sm">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-center justify-center p-5 border-b border-solid border-blueGray-200 rounded-t">
                <CheckCircle size="40" color="#68d391"/> 
                </div>
                {/*body*/}
                <div className="relative p-6 flex-auto">
                  <h4 className="text-3xl font-bold text-center text-green-500">{title}</h4>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-4 border-t border-solid border-blueGray-200 rounded-b">
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => {
                      onClose();
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};
